import { useState } from "react";
import api from "../api/client";
import { useToast } from "../store/toast";
import { Modal } from "./ui";
import RecipientPicker from "./RecipientPicker";
import { STATUS } from "../constants";
import { fmtDate } from "../utils";

export default function TasksEmailModal({ open, onClose, tasks, onSent }) {
  const { push } = useToast();
  const [rcpts, setRcpts] = useState({ to: [], cc: [], bcc: [] });
  const [observation, setObservation] = useState("");
  const [notes, setNotes] = useState({});
  const [sending, setSending] = useState(false);

  const total = rcpts.to.length + rcpts.cc.length + rcpts.bcc.length;

  const send = async () => {
    if (total === 0) return push("Elige a quién enviar", "warning");
    setSending(true);
    try {
      await api.post("/reports/tasks-email", {
        task_ids: tasks.map((t) => t.id), to: rcpts.to, cc: rcpts.cc, bcc: rcpts.bcc, observation, notes,
      });
      push("Correo enviado", "success");
      onSent?.(); onClose();
    } catch (e) { push(e.response?.data?.detail || "No se pudo enviar (¿SMTP configurado?)", "error"); }
    finally { setSending(false); }
  };

  return (
    <Modal open={open} onClose={onClose} wide title={`Enviar ${tasks.length} tarea(s) por correo`}>
      <div className="space-y-4">
        <div>
          <label className="label">Destinatarios (usuarios del sistema + directorio)</label>
          <RecipientPicker onChange={setRcpts} />
        </div>

        <div>
          <label className="label">Observación general (cuerpo del correo)</label>
          <textarea className="input" rows={2} value={observation} onChange={(e) => setObservation(e.target.value)} placeholder="Mensaje que verá el destinatario…" />
        </div>

        <div>
          <label className="label">Tareas seleccionadas (puedes anexar una nota a cada una)</label>
          <div className="max-h-56 space-y-2 overflow-y-auto rounded-lg border border-slate-200 p-2">
            {tasks.map((t) => (
              <div key={t.id} className="rounded-lg bg-slate-50 p-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="font-medium uppercase">{t.title}</span>
                  <span className="text-xs text-slate-400">{fmtDate(t.start_date)} → {fmtDate(t.due_date)} · {STATUS[t.status]?.label}</span>
                </div>
                <input className="input mt-1 text-xs" placeholder="Nota de esta tarea (opcional)"
                  value={notes[t.id] || ""} onChange={(e) => setNotes((n) => ({ ...n, [t.id]: e.target.value }))} />
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button className="btn-ghost" onClick={onClose}>Cancelar</button>
          <button className="btn-primary" onClick={send} disabled={sending}>{sending ? "Enviando…" : "Enviar"}</button>
        </div>
      </div>
    </Modal>
  );
}
